<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-info" @click.prevent="edit()">
        <i class="fas fa-pencil-alt"></i><span class="d-none d-lg-inline"> Editar</span>
      </d-button>
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import RepresentativeService from '_services/rest/modules/representative';
import { _DELETE_REPRESENTATIVE_, _EDIT_REPRESENTATIVE_ } from '_modules/representative/components/RepresentativeModel';

export default {
  name: 'representative-buttons',
  props: {
    representative: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    blockAccess() {
      const status = (this.representative.status === 1) ? 0 : 1;
      RepresentativeService.toggleAccess(this.representative.id, status)
        .then(() => {
          this.$router.push({ name: 'admin-representative-list', params: { page: 1 } });
          Events.$emit('update:pagination', { page: 1 });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    edit() {
      this.setToggle({ type: 'edit_representative_modal', bool: true });
      Events.$emit(_EDIT_REPRESENTATIVE_, this.representative);
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_REPRESENTATIVE_, this.representative);
    },
  },
  mounted() {},
};
</script>
